
const state = {
  msgNum: 0,
  socketFlag:0
}

const mutations = {
  SET_NUM: (state, num) => {
    state.msgNum = num
  },
  SET_SOCKETFLAG: (state, num) => {
    state.socketFlag = num
  },
}

const actions = {
  setNum({ commit, state }, num) {
    commit('SET_NUM', num)
  },
  setSocketFlag({ commit, state }, num) {
    commit('SET_SOCKETFLAG', num)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
